import React from "react";
import { Page, Document } from "react-pdf";

class ApDisplayPdf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      pageNumber: 1
    };
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const { pageNumber, numPages } = this.state;

    return (
      <div>
        <Document file={this.props.file} onLoadSuccess={this.onDocumentLoad}>
          <Page
            pageNumber={pageNumber}
            renderAnnotations={false}
            renderTextLayer={false}
            onRenderSuccess={() => this.props.requestUpdate()}
            renderMode="svg"
          />
        </Document>
      </div>
    );
  }
}

export default ApDisplayPdf;



// WEBPACK FOOTER //
// ./src/components/approval/ApDisplayPdf.js